import { Button, Tooltip } from '@mui/material';
import PlayIcon from '@mui/icons-material/PlayArrow';
import StopIcon from '@mui/icons-material/Pause';
import { useTranslation } from 'react-i18next';
import { FC } from 'react';

type PlayPauseButtonProps = {
  isPlaying: boolean;
  onToggle(): void;
};

export const PlayPauseButton: FC<PlayPauseButtonProps> = ({ isPlaying, onToggle }) => {
  const { t } = useTranslation();
  return (
    <Tooltip title={t(isPlaying ? 'player.controls.pause' : 'player.controls.play')} placement="top">
      <Button color="secondary" variant="contained" sx={{ minWidth: '48px' }} onClick={onToggle}>
        {isPlaying ? <StopIcon /> : <PlayIcon />}
      </Button>
    </Tooltip>
  );
};
